import { render, staticRenderFns } from "./buystore.vue?vue&type=template&id=23717dc8&"
import script from "./buystore.vue?vue&type=script&lang=js&"
export * from "./buystore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports